import Star_20 from '../assets/Star_20.svg'
import Star_22 from '../assets/Star_22.svg'
// import Star_24 from '../assets/Star_24.svg'
// import Star_25 from '../assets/Star_25.svg'
// import Star_26 from '../assets/Star_26.svg'

const PromoBanner = () => {
  return (
    <div className="h-[115px] bg-brand-dark overflow-hidden relative">
      <div className="absolute inset-0 opacity-30 bg-[radial-gradient(circle_at_center,_#4CBC18,_transparent_60%)]" />

      <img
        src={Star_20}
        alt="star"
        className="absolute left-[280px] top-[36px] w-[24px]"
      />

      <img
        src={Star_22}
        alt="star"
        className="absolute right-[320px] top-[28px] w-[18px]"
      />

      <div className="relative h-full flex flex-col items-center justify-center text-center">
        <h3 className="text-[20px] font-extrabold text-white">
          <span className="text-brand-green">50% Off</span> First Year for Founding Users!
        </h3>

        <p className="text-white/80 mt-1 text-[14px] italic">
          Join the first 100 Pro annual subscribers and enjoy early access as new features roll out.
        </p>
      </div>
    </div>
  )
}

export default PromoBanner